import { __makeTemplateObject, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React, { useRef, useState, useEffect } from 'react';
import { ActionMenu, ActionList, Box, Spinner } from '@primer/react';
import styled from 'styled-components';
import LTIconButton from '../LTIconButton/index.js';
import { isEnterOrSpacePressed } from '../../utils/functions.js';
import LTCounterLabel from '../LTCounterLabel/index.js';
import LTText from '../LTText/index.js';
import LTDivider from '../LTDivider/index.js';
import ArrowRight from '../../icons/ArrowRight.js';

/**
 * @param {string} anchorType The type of the anchor CTA.
 * @param {!Array<!Object<string, *>} options Dropdown options in the menu.
 * @param {string} placeholder The placeholder of the button anchorType.
 * @param {string} leadingIcon The leadingIcon of the button anchorType.
 * @param {string} title The title of the menu items.
 * @param {string} menuSize Size of the menu.
 * @param {boolean} showFilterCount Whether to show filter count in anchor.
 * @param {string} groupTitleVisual The visual to be shown with action group heading.
 * @param {string} selectionVariant Shows check icon for selected list item.
 * @param {string} isLoading Loader when options are loading
 * @param {function} onButtonClick Callback function when button is clicked.
 * @param {!Element} customOverlay Custom overlay to be shown in the menu.
 * @param {string} activeId The active name of the selected list item.
 */
var StyledSpinnerLi = styled.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  padding: 12px 0px;\n"], ["\n  display: flex;\n  justify-content: center;\n  padding: 12px 0px;\n"])));
var LTActionMenu = function LTActionMenu(_a) {
  var _b;
  var _c = _a.activeId,
    activeId = _c === void 0 ? "" : _c,
    _d = _a.anchorType,
    anchorType = _d === void 0 ? LTActionMenu.AnchorType.ICON : _d,
    _e = _a.anchorButtonSize,
    anchorButtonSize = _e === void 0 ? LTIconButton.Size.MEDIUM : _e,
    _f = _a.buttonId,
    buttonId = _f === void 0 ? "" : _f,
    _g = _a.buttonLabel,
    buttonLabel = _g === void 0 ? "" : _g,
    _h = _a.buttonStyle,
    buttonStyle = _h === void 0 ? {} : _h,
    _j = _a.tabIndex,
    tabIndex = _j === void 0 ? 0 : _j,
    _k = _a.counterValue,
    counterValue = _k === void 0 ? null : _k,
    _l = _a.customAnchor,
    customAnchor = _l === void 0 ? null : _l,
    _m = _a.customOverlay,
    customOverlay = _m === void 0 ? null : _m,
    _o = _a.descriptionStyle,
    descriptionStyle = _o === void 0 ? {} : _o,
    _p = _a.groupTitleVisual,
    groupTitleVisual = _p === void 0 ? null : _p,
    _q = _a.iconButtonVariant,
    iconButtonVariant = _q === void 0 ? LTActionMenu.ButtonVariant.DEFAULT : _q,
    _r = _a.isLoading,
    isLoading = _r === void 0 ? false : _r,
    _s = _a.leadingIcon,
    leadingIcon = _s === void 0 ? "" : _s,
    _t = _a.listItemStyle,
    listItemStyle = _t === void 0 ? {} : _t,
    _u = _a.menuSize,
    menuSize = _u === void 0 ? LTActionMenu.MenuOverlaySizes.SMALL : _u,
    _v = _a.onButtonClick,
    onButtonClick = _v === void 0 ? function () {} : _v,
    _w = _a.options,
    options = _w === void 0 ? [] : _w,
    _x = _a.overlayStyle,
    overlayStyle = _x === void 0 ? {} : _x,
    _y = _a.selectionVariant,
    selectionVariant = _y === void 0 ? LTActionMenu.SelectionVariant.NONE : _y,
    _z = _a.title,
    title = _z === void 0 ? "" : _z,
    _0 = _a.width,
    width = _0 === void 0 ? 320 : _0;
  var ltActionMenuButton = useRef(null);
  var _1 = useState(false),
    openMenu = _1[0],
    setOpenMenu = _1[1];
  var showCount = counterValue !== null && counterValue !== "";
  useEffect(function () {
    if (ltActionMenuButton.current && tabIndex !== 0) {
      // This is done to set the tabIndex of the anchor button
      // primer has a bug where it overrides the tabIndex to 0
      ltActionMenuButton.current.tabIndex = tabIndex;
    }
  }, []);
  useEffect(function () {
    if (openMenu) {
      setTimeout(function () {
        var elems = document.getElementsByClassName("sentinel");
        for (var i = 0; i < (elems === null || elems === void 0 ? void 0 : elems.length); i++) {
          elems[i].setAttribute("tabindex", "-1");
        }
      }, 0);
    }
    if (!title) {
      return;
    }
    var actionListGroupElement = document.getElementsByClassName("actionListGroup-".concat(title))[0];
    var removeAttributesFromFirstChildDiv = function removeAttributesFromFirstChildDiv(element) {
      if (element && element.children.length > 0) {
        var firstChildDiv = element.children[0];
        firstChildDiv.removeAttribute("role");
        firstChildDiv.removeAttribute("aria-hidden");
      }
    };
    removeAttributesFromFirstChildDiv(actionListGroupElement);
  }, [openMenu]);
  var titleId = title.replace(/\s+/g, "-");
  return /*#__PURE__*/React.createElement(ActionMenu, {
    anchorRef: ltActionMenuButton,
    "aria-label": "".concat(title, " Menu"),
    open: openMenu,
    onOpenChange: function onOpenChange(open) {
      setOpenMenu(open);
      if (typeof onButtonClick === "function") onButtonClick(open);
    },
    sx: {
      width: width
    }
  }, customAnchor ? /*#__PURE__*/React.createElement(ActionMenu.Anchor, null, customAnchor) : anchorType === LTActionMenu.AnchorType.BUTTON || showCount || buttonLabel ? /*#__PURE__*/React.createElement(ActionMenu.Button, {
    "aria-controls": openMenu ? "lt-action-menu-overlay-".concat(titleId) : undefined,
    "aria-haspopup": true,
    "aria-expanded": openMenu,
    "aria-label": "Open ".concat(buttonLabel, " Menu, Press Enter to view "),
    className: "lt-action-menu-button",
    id: buttonId,
    leadingIcon: leadingIcon,
    onClick: function onClick() {
      return setOpenMenu(!openMenu);
    },
    size: anchorButtonSize,
    sx: __assign(__assign({}, buttonStyle), {
      "> span:nth-child(2)": {
        display: showCount ? "none" : {}
      }
    }),
    tabIndex: tabIndex
  }, buttonLabel || showCount ?
  /*#__PURE__*/
  // added to avoid empty button content element
  React.createElement(React.Fragment, null, buttonLabel, showCount && /*#__PURE__*/React.createElement("span", {
    "aria-hidden": true
  }, /*#__PURE__*/React.createElement(LTCounterLabel, {
    count: counterValue,
    addDefaultMargin: !!buttonLabel
  }))) : null) : /*#__PURE__*/React.createElement(ActionMenu.Anchor, null, /*#__PURE__*/React.createElement(LTIconButton, {
    "aria-controls": openMenu ? "lt-action-menu-overlay-".concat(titleId) : undefined,
    "aria-label": "Open ".concat(title, " Menu, Press Enter to view "),
    "aria-haspopup": true,
    "aria-expanded": openMenu,
    className: "lt-action-menu-button",
    customStyle: buttonStyle,
    icon: leadingIcon,
    size: anchorButtonSize,
    tabIndex: tabIndex,
    variant: iconButtonVariant
  })), /*#__PURE__*/React.createElement(ActionMenu.Overlay, {
    "aria-label": "".concat(title, " Menu"),
    "aria-modal": "true",
    className: "lt-action-menu-overlay",
    role: "dialog",
    width: menuSize,
    sx: __assign({}, overlayStyle)
  }, customOverlay ? customOverlay : /*#__PURE__*/React.createElement(ActionList, {
    selectionVariant: selectionVariant,
    role: "menu",
    id: "lt-action-menu-overlay-".concat(titleId),
    tabIndex: undefined,
    sx: (_b = {}, _b["@media screen and (max-width: 1024px)"] = {
      // minHeight: "100px",
      maxHeight: "250px",
      overflow: "auto"
    }, _b.padding = "0", _b)
  }, /*#__PURE__*/React.createElement(ActionList.Group, {
    className: "actionListGroup-".concat(title),
    tabIndex: undefined,
    title: (title || groupTitleVisual) && /*#__PURE__*/React.createElement("li", {
      role: "menuitem"
    }, /*#__PURE__*/React.createElement(Box, {
      sx: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "4px 0"
      }
    }, /*#__PURE__*/React.createElement(LTText, {
      as: "h4",
      sx: {
        color: "fg.default",
        margin: 0
      },
      variant: LTText.TextVariant.SUBHEADER_BOLD
    }, title), groupTitleVisual))
  }, title && /*#__PURE__*/React.createElement(LTDivider, null), isLoading ? /*#__PURE__*/React.createElement(StyledSpinnerLi, {
    as: "li"
  }, /*#__PURE__*/React.createElement(Spinner, {
    size: "medium",
    "aria-label": "Loading options..."
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, options.map(function (_a, index) {
    var title = _a.title,
      _b = _a.list,
      list = _b === void 0 ? [] : _b;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(React.Fragment, null, index !== 0 && /*#__PURE__*/React.createElement(LTDivider, null)), title && /*#__PURE__*/React.createElement("li", {
      role: "none"
    }, /*#__PURE__*/React.createElement(Box, {
      sx: {
        backgroundColor: "bg.muted",
        color: "fg.muted",
        fontSize: "12px",
        fontWeight: "600",
        lineHeight: "18px",
        padding: "8px 16px",
        margin: 0
      }
    }, /*#__PURE__*/React.createElement(LTText, {
      as: "h5",
      sx: {
        color: "fg.default",
        margin: 0
      },
      variant: LTText.TextVariant.SMALL_REGULAR
    }, title)), /*#__PURE__*/React.createElement(LTDivider, null)), /*#__PURE__*/React.createElement(ActionList.Group, {
      key: "".concat(index, "-").concat(title),
      sx: {
        marginTop: "0px !important",
        "& > div": {
          padding: "0" // div is options header
        },

        "& > ul": {
          padding: "8px 0" // ul is options list
        }
      }
    }, /*#__PURE__*/React.createElement(React.Fragment, null, list === null || list === void 0 ? void 0 : list.map(function (item, index) {
      var _a = item || {},
        _b = _a.description,
        description = _b === void 0 ? "" : _b,
        _c = _a.disabled,
        disabled = _c === void 0 ? false : _c,
        _d = _a.id,
        id = _d === void 0 ? "" : _d,
        _e = _a.isSelected,
        isSelected = _e === void 0 ? false : _e,
        _f = _a.isSubMenu,
        isSubMenu = _f === void 0 ? false : _f,
        _g = _a.leadingVisual,
        leadingVisual = _g === void 0 ? "" : _g,
        _h = _a.name,
        name = _h === void 0 ? "" : _h,
        _j = _a.onClickHandler,
        onClickHandler = _j === void 0 ? function () {} : _j,
        options = _a.options,
        _k = _a.variant,
        variant = _k === void 0 ? LTActionMenu.ButtonVariant.DEFAULT : _k,
        _l = _a.visual,
        visual = _l === void 0 ? "" : _l;
      var actionListItem = /*#__PURE__*/React.createElement(ActionList.Item, __assign({
        "aria-describedby": description ? "ActionList-".concat(index) || null : undefined,
        "aria-labelledby": null,
        "aria-label": name
      }, id && {
        id: id
      }, {
        disabled: disabled,
        key: "".concat(index, "-").concat(name),
        onClick: function onClick() {
          if (!isSubMenu && !disabled) {
            onClickHandler(ltActionMenuButton);
            setOpenMenu(!openMenu);
          }
        },
        onKeyDown: function onKeyDown(e) {
          if (!e.metaKey) {
            e.preventDefault();
          }
          if (isEnterOrSpacePressed(e, false)) {
            if (!isSubMenu) {
              onClickHandler(ltActionMenuButton);
              setOpenMenu(!openMenu);
            }
          } else if (e.key === "Escape") {
            setOpenMenu(false);
          }
        },
        role: selectionVariant ? "menuitemradio" : "menuitem"
      }, selectionVariant && {
        selected: activeId === name || isSelected
      }, !selectionVariant && {
        active: activeId === name
      }, {
        sx: __assign(__assign({
          width: "none"
        }, listItemStyle), {
          "&:hover": {
            outline: "1px solid",
            outlineColor: variant === LTActionMenu.ButtonVariant.DANGER ? "border.danger" : "border.invisibleBtn"
          }
        }),
        tabIndex: 0,
        variant: variant
      }), leadingVisual && /*#__PURE__*/React.createElement(ActionList.LeadingVisual, null, leadingVisual), /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, name), /*#__PURE__*/React.createElement(ActionList.TrailingVisual, null, isSubMenu ? /*#__PURE__*/React.createElement(ArrowRight, null) : visual), description && /*#__PURE__*/React.createElement(LTText, {
        as: "div",
        color: "text.muted",
        id: "ActionList-".concat(index),
        style: __assign({}, descriptionStyle),
        text: description,
        variant: LTText.TextVariant.SMALL_REGULAR
      }));
      return /*#__PURE__*/React.createElement(React.Fragment, null, isSubMenu ? /*#__PURE__*/React.createElement(LTActionMenu, {
        customAnchor: actionListItem,
        options: options,
        selectionVariant: LTActionMenu.SelectionVariant.SINGLE
      }) : actionListItem);
    }))));
  }))))));
};
// Static properties for TypeScript
LTActionMenu.MenuOverlaySizes = {
  LARGE: "large",
  MEDIUM: "medium",
  SMALL: "small"
};
LTActionMenu.AnchorType = {
  ICON: "icon",
  BUTTON: "button"
};
LTActionMenu.SelectionVariant = {
  NONE: "",
  SINGLE: "single"
};
LTActionMenu.ButtonVariant = {
  DANGER: "danger",
  DEFAULT: "default",
  INVISIBLE: "invisible",
  OUTLINE: "outline",
  PRIMARY: "primary"
};
var templateObject_1;

export { LTActionMenu as default };
